import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
  shallowEqual,
} from 'react-redux';
import type { RootState, AppDispatch } from './store';

export const shallow = shallowEqual;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useShallowEqualSelector: TypedUseSelectorHook<RootState> = (
  selector
) => useSelector(selector, shallowEqual);

export {
  fetchSettings,
  patchSettings,
  selectSettings,
} from './slices/settingsSlice';

export {
  fetchPowerBiReports,
  fetchPowerBiReportsList,
  createSharedPowerBiReport,
  removeSharedPowerBiReport,
  selectPowerBiReports,
} from './slices/powerBiReportsSlice';

export { fetchPermissions, selectPermissions } from './slices/permissionsSlice';
